import clsx from 'clsx'
import React from 'react'

import styles from '@Components/Status/styles.module.scss'

const Status = ({
  className,
  color = 'none',
}: {
  className?: string
  color?: 'green' | 'red' | string
}) => (
  <div className={clsx(styles.status, color, className)} />
)

export default Status
